import { render, staticRenderFns } from "./knowledges.vue?vue&type=template&id=3f2f3ef1&scoped=true"
import script from "./knowledges.vue?vue&type=script&lang=js"
export * from "./knowledges.vue?vue&type=script&lang=js"
import style0 from "./knowledges.vue?vue&type=style&index=0&id=3f2f3ef1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f3ef1",
  null
  
)

export default component.exports